import httpClient from "@/http-client";

export const get = (options = {}) => {
    return httpClient
        .get("/api/cash-transfers", options)
        .then(response => Promise.resolve(response.data))
        .catch(error => Promise.reject(error.response.data));
};

export const store = data => {
    return httpClient
        .post("/api/cash-transfers", data)
        .then(response => Promise.resolve(response.data))
        .catch(error => Promise.reject(error.response.data));
};

export const find = (id, options = {}) => {
    return httpClient
        .get(`/api/cash-transfers/${id}`, options)
        .then(response => Promise.resolve(response.data))
        .catch(error => Promise.reject(error.response.data));
};

export const update = (id, data) => {
    return httpClient
        .put(`/api/cash-transfers/${id}`, data)
        .then(response => Promise.resolve(response.data))
        .catch(error => Promise.reject(error.response.data));
};

export const destroy = id => {
    return httpClient
        .delete(`/api/cash-transfers/${id}`)
        .then(response => Promise.resolve(response.data))
        .catch(error => Promise.reject(error.response.data));
};

export const approveOrReject = (id, data) => {
    return httpClient
        .put(`/api/cash-transfers/${id}/approve-or-reject`, data)
        .then(response => Promise.resolve(response.data))
        .catch(error => Promise.reject(error.response.data));
};

export const bankSlip = (id, data) => {
    return httpClient
        .put(`/api/cash-transfers/${id}/bank-slip`, data)
        .then(response => Promise.resolve(response.data))
        .catch(error => Promise.reject(error.response.data));
};

export const photoUpload = data => {
    return httpClient
        .post("/api/cash-transfers/photos", data)
        .then(response => Promise.resolve(response.data))
        .catch(error => Promise.reject(error.response.data));
};

export const employees = (options = {}) => {
    return httpClient
        .get("/api/cash-transfers/employees", options)
        .then(response => Promise.resolve(response.data))
        .catch(error => Promise.reject(error.response.data));
};

export const currencies = (options = {}) => {
    return httpClient
        .get("/api/cash-transfers/currencies", options)
        .then(response => Promise.resolve(response.data))
        .catch(error => Promise.reject(error.response.data));
};

export const banks = (options = {}) => {
    return httpClient
        .get("/api/cash-transfers/banks", options)
        .then(response => Promise.resolve(response.data))
        .catch(error => Promise.reject(error.response.data));
};

export default {
    get,
    store,
    find,
    update,
    destroy,
    approveOrReject,
    bankSlip,
    photoUpload,
    employees,
    currencies,
    banks
};
